import React from "react";
import s from "./style.module.scss";
import GoBack from "shared/ui/GoBack";
import { StatusesContent } from "widgets/StatusesContent";

const Statuses: React.FC = () => {
  return (
    <main className={s.statuses}>
      <GoBack black />
      <h1>О статусах</h1>

      <StatusesContent />
    </main>
  );
};

export default Statuses;
